import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from '@/view/components/ui/use-toast'
import { consultService } from '../services/consultService'

export const useConsultsMutations = () => {
  const queryClient = useQueryClient()

  const deleteConsultMutation = useMutation({
    mutationFn: (id: string) => consultService.deleteConsultById(id),
    onSuccess: () => {
      toast({
        title: 'Consulta deletada com sucesso',
        description: 'A consulta foi removida do sistema',
        variant: 'default',
      })
      queryClient.invalidateQueries({ queryKey: ['consults'] })
    },
    onError: () => {
      toast({
        title: 'Erro ao deletar consulta',
        description: 'Por favor, tente novamente mais tarde',
        variant: 'destructive',
      })
    },
  })

  const configureConsultMutation = useMutation({
    mutationFn: consultService.configureConsults,
    onSuccess: () => {
      toast({
        title: 'Configuração aplicada com sucesso',
        description: 'A configuração foi aplicada corretamente',
        variant: 'default',
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao configurar',
        description: 'Verifique os dados enviados e tente novamente',
        variant: 'destructive',
      })
    },
  })

  const deleteAllConsultsMutation = useMutation({
    mutationFn: consultService.deleteAllConsults,
    onSuccess: () => {
      toast({
        title: 'Todas as consultas foram deletadas',
        description: 'As consultas foram removidas do sistema com sucesso',
        variant: 'default',
      })
      queryClient.invalidateQueries({ queryKey: ['consults'] })
    },
    onError: () => {
      toast({
        title: 'Erro ao deletar todas as consultas',
        description: 'Por favor, tente novamente mais tarde',
        variant: 'destructive',
      })
    },
  })

  return {
    deleteConsultMutation,
    configureConsultMutation,
    deleteAllConsultsMutation,
  }
}
